<template>
  <div>
    <Head :title="contentable.name" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="Link" href="/verticals">Verticals</b-breadcrumb-item>
      <b-breadcrumb-item tag="Link" :href="`/verticals/${contentable.id}/edit`">{{ contentable.name }}</b-breadcrumb-item>
      <b-breadcrumb-item tag="Link" active>Site Content</b-breadcrumb-item>
    </b-breadcrumb>
    <trashed-message v-if="contentable.deleted_at" class="mb-6" @restore="restore"> This vertical has been deleted.</trashed-message>
    <form @submit.prevent="update">
      <card-component>
        <div v-for="(section, index) in siteContentJson.sections" :key="section+index">
          {{ section.title }}
          <div v-html="section.body" />
          <hr />
        </div>
        <div class="is-flex is-justify-content-flex-end px-8 py-4">
          <b-button type="is-info" native-type="submit">
            Save
          </b-button>
        </div>
      </card-component>
      <div v-for="(section, index) in siteContentJson.sections" :key="section+index">
        <card-collapsible :open="true" :title="section.title">
          <!--          <div v-show="isSectionEnabled(index)" style="display: inline">-->
          <div>
            <text-input v-model="section.title" class="mb-2" label="Title" @input="updateJson" />
            <wysiwyg v-model="section.body" name="html-editor" @change="updateJson" />
          </div>
          <b-button type="is-info" @click="removeSection(index)">
            Delete Section
          </b-button>
        </card-collapsible>
      </div>
      <b-button type="is-info" @click="addSection">
        Add Section
      </b-button>
    </form>
  </div>
</template>

<script>
//import { Head, Link } from '@inertiajs/vue2'
import axios from 'axios'
import debounce from 'lodash/debounce'
import Layout from '@/Shared/Layout.vue'
import TextInput from '@/Shared/TextInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import CardComponent from '@/Shared/CardComponent.vue'
import CardCollapsible from '@/Shared/CardCollapsible.vue'
// import { VueEditor } from 'vue2-editor'
export default {
  components: {
    CardComponent,
    CardCollapsible,
    LoadingButton,
    TextInput,
    // VueEditor,
  },
  layout: Layout,
  props: {
    siteContent: Object,
    contentable: Object,
  },
  remember: ['domainCreate','domainSearch'],
  data() {
    return {
      show: false,
      enabledSections: {},
      siteContentJson: {},
      form: this.$inertia.form({
        json: this.siteContent.json || '{"sections": []}',
      }),
    }
  },
  computed:{
  },
  mounted() {
    this.siteContentJson = JSON.parse(this.form.json)
  },
  methods: {
    update() {
      this.form.put("/site-content/"+this.siteContent.id)
    },
    // isSectionEnabled(index){
    //   return index in this.enabledSections
    // },
    // toggleSection(title) {
    //   console.log(this.isSectionEnabled(title))
    //   if (this.enabledSections[title]) {
    //     this.show = false
    //     delete (this.enabledSections[title])
    //   } else {
    //     this.show = true
    //     this.enabledSections[title] = 1
    //   }
    // },
    updateJson(){
      this.form.json = JSON.stringify(this.siteContentJson)
    },
    addSection(){
      this.siteContentJson.sections.push({title:'No Title', body: ''})
    },
    removeSection(index){
      this.siteContentJson.sections.splice(index,1)
    },
  },
}
</script>
